<div
  data-testid="multi-section-filter-btn"
  #trigger="cdkOverlayOrigin"
  (click)="isOpen = true" cdkOverlayOrigin class="filter-button status-filter flex flex-row gap-[20px]" type="button"
>
  <div class="label text-type-8">{{ buttonLabel }}</div>
  <mat-icon
    class="filter-icon"
    svgIcon="filters"
  />
</div>

<ng-template
  (backdropClick)="isOpen = false"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  cdkConnectedOverlay
>
  <div class="project-details-page-status-filter-popup" data-testid="multi-section-filter-popup">
    <div class="filter-tabs" role="tablist">
      @for (section of visibleSections; track section.key) {
        <button
          type="button"
          class="filter-tab"
          [attr.data-testid]="'filter-tab-' + section.key"
          [class.active]="activeSection?.key === section.key"
          (click)="selectTab(section.key)"
        >
          {{ section.label }}
        </button>
      }
    </div>

    <div class="filter-tab-content">
      @if (activeSection; as section) {
        @for (s of [section]; track s.key) {
          <app-checkbox-list-with-filter
            (selectionChange)="onSelectionChange(s, $event)"
            [displaySearch]="!!s.searchable"
            [displaySelectAll]="!s.hideAll"
            [options]="s.options"
            [parentFormGroup]="searchForm"
            [controlName]="s.key + 'Search'"
          />
        }
      }
    </div>
  </div>
</ng-template>
